export default __webpack_public_path__ + "static/media/torso-top-back.9f0f49a5.png";